import * as React from 'react';
import type {ComponentProps, PartData} from '@enonic/react-components';
import HeroPrototype from './prototype/Hero';

interface HeroStandardImage {
    src: string;
    alt: string;
}

interface HeroStandardCta {
    label: string;
    href: string;
    isExternal: boolean;
}

interface HeroStandardData {
    overline?: string;
    heading?: string;
    images?: HeroStandardImage[];
    primaryCta?: HeroStandardCta;
    secondaryCta?: HeroStandardCta;
}

export function HeroStandard({data}: ComponentProps<PartData>) {
    const {overline, heading, images = [], primaryCta, secondaryCta} = (data || {}) as HeroStandardData;

    return (
        <HeroPrototype
            overline={overline}
            heading={heading || ''}
            images={images}
            primaryCta={primaryCta}
            secondaryCta={secondaryCta}
        />
    );
}
